import { render } from "./AboveFold.vue?vue&type=template&id=5cc3d670&scoped=true"
import script from "./AboveFold.vue?vue&type=script&lang=js"
export * from "./AboveFold.vue?vue&type=script&lang=js"

import "./AboveFold.vue?vue&type=style&index=0&id=5cc3d670&lang=scss&scoped=true"

import exportComponent from "/var/www/ascentcontrols/landingpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc3d670"]])

export default __exports__